@if (isV2()) {
	<div class="assignment-v2-overlay">
		<button
			type="button"
			class="assignment-v2-scrim"
			(click)="close()"
			[attr.aria-label]="'ASSIGNMENT__BUTTON_CANCEL' | transloco"
		></button>
		<div class="assignment-v2" [class.assignment-v2--ready]="ready">
		<header class="assignment-v2-header">
			<h2 class="assignment-v2-title">
				{{
					(isCreate() ? "ASSIGNMENT_MODAL__CREATE_TITLE" : "ASSIGNMENT_MODAL__TITLE")
						| transloco
				}}
			</h2>
			<button type="button" class="assignment-v2-close" (click)="close()" [attr.aria-label]="'ASSIGNMENT__BUTTON_CANCEL' | transloco">
				<span class="material-symbols-outlined" aria-hidden="true">close</span>
			</button>
		</header>

		@if (ready) {
			<div class="assignment-v2-body" [formGroup]="assignmentForm">
				@if (sourceContext) {
					<section class="assignment-v2-source">
						<p class="assignment-v2-source-label">
							<span class="material-symbols-outlined" aria-hidden="true">link</span>
							{{ "ASSIGNMENT_MODAL__CREATED_FROM" | transloco }}
						</p>
						<p class="assignment-v2-source-question">{{ sourceContext.questionText }}</p>
						<p class="assignment-v2-source-meta">
							<span class="material-symbols-outlined" aria-hidden="true">location_on</span>
							<span>{{ sourceContext.locationName }}</span>
						</p>
						@if (sourceContext.checklistName) {
							<p class="assignment-v2-source-meta">
								<span class="material-symbols-outlined" aria-hidden="true">assignment</span>
								<span>{{ sourceContext.checklistName }}</span>
							</p>
						}
					</section>
				} @else if (trigger != null) {
					<section class="assignment-v2-source">
						@if (trigger.description === "") {
							<p class="assignment-v2-source-meta">{{ "ASSIGNMENT_MODAL__DESCRIPTION" | transloco }}</p>
						} @else {
							<p class="assignment-v2-source-meta">{{ trigger.description }}</p>
						}
					</section>
				}

				<label class="assignment-v2-field">
					<span class="assignment-v2-field-label">
						{{ "ASSIGNMENT__TITLE" | transloco }}<span
							class="assignment-v2-required"
							[class.assignment-v2-required--invalid]="
								assignmentForm.controls.title.invalid && assignmentForm.controls.title.touched
							"
							aria-hidden="true"
							>*</span
						>
					</span>
					<ion-input
						class="title assignment-v2-input"
						#title
						fill="outline"
						formControlName="title"
					></ion-input>
					@if (assignmentForm.controls.title.invalid && assignmentForm.controls.title.touched) {
						<p class="assignment-v2-error">{{ "ASSIGNMENT__TITLE_EMPTY" | transloco }}</p>
					}
				</label>

				<label class="assignment-v2-field">
					<span class="assignment-v2-field-label">{{ "ASSIGNMENT__DESCRIPTION" | transloco }}</span>
					<div class="assignment-v2-description">
						<quill-editor [modules]="modulesV2" formControlName="description"></quill-editor>
					</div>
				</label>

				@if (viewConfig.showAssignee) {
					<div class="assignment-v2-field">
						<span class="assignment-v2-field-label">
							{{ "ASSIGNMENT__ASSIGNEE" | transloco }}<span
								class="assignment-v2-required"
								[class.assignment-v2-required--invalid]="
									assignmentForm.controls.assignees.invalid &&
									assignmentForm.controls.assignees.touched
								"
								aria-hidden="true"
								>*</span
							>
						</span>
						<app-assignment-assignees
							formControlName="assignees"
							[definition]="definition"
							[v2]="true"
						></app-assignment-assignees>
						@if (
							assignmentForm.controls.assignees.invalid && assignmentForm.controls.assignees.touched
						) {
							<p class="assignment-v2-error">{{ "ASSIGNMENT__ASSIGNEE_EMPTY" | transloco }}</p>
						}
					</div>
				}

				@if (viewConfig.showPriority) {
					<div class="assignment-v2-field">
						<span class="assignment-v2-field-label">{{ "ASSIGNMENT__PRIORITY" | transloco }}</span>
						@if (definition?.priorities.length > 0) {
							<ion-select
								fill="outline"
								labelPlacement="stacked"
								formControlName="definitionPriority"
								[compareWith]="compareWith"
							>
								<ion-select-option *ngFor="let priority of definition.priorities" [value]="priority">
									{{ priority.name }}
								</ion-select-option>
							</ion-select>
						} @else {
							<div class="assignment-v2-priority">
								<button
									type="button"
									class="assignment-v2-priority-btn"
									[class.assignment-v2-priority-btn--active]="
										assignmentForm.controls.priority.value !== true
									"
									(click)="setPriority(false)"
								>
									<span class="material-symbols-outlined" aria-hidden="true">flag</span>
									{{ "ASSIGNMENT__PRIORITY_NO" | transloco }}
								</button>
								<button
									type="button"
									class="assignment-v2-priority-btn assignment-v2-priority-btn--high"
									[class.assignment-v2-priority-btn--active]="
										assignmentForm.controls.priority.value === true
									"
									(click)="setPriority(true)"
								>
									<span class="material-symbols-outlined" aria-hidden="true">flag</span>
									{{ "ASSIGNMENT__PRIORITY_YES" | transloco }}
								</button>
							</div>
						}
					</div>
				}

				@if (viewConfig.showDateTime) {
					<div class="assignment-v2-datetime">
						<label class="assignment-v2-field">
							<span class="assignment-v2-field-label">{{ "ASSIGNMENT__TIME_START" | transloco }}</span>
							<div class="assignment-v2-deadline">
								<ion-datetime-button datetime="start-v2"></ion-datetime-button>
							</div>
						</label>
						<label class="assignment-v2-field">
							<span class="assignment-v2-field-label">{{ "ASSIGNMENT__DEADLINE" | transloco }}</span>
							<div class="assignment-v2-deadline">
								<ion-datetime-button datetime="deadline-v2"></ion-datetime-button>
							</div>
						</label>
					</div>
				}

				<div class="assignment-v2-field">
					<span class="assignment-v2-field-label">{{ "ATTACHMENTS__HEADLINE" | transloco }}</span>
					<app-attachments
						formControlName="attachments"
						[showAttachments]="true"
						[v2]="true"
						[hideHeadline]="true"
					></app-attachments>
				</div>

				<button
					type="button"
					class="assignment-v2-accordion"
					(click)="moreDetailsOpen = !moreDetailsOpen"
					[attr.aria-expanded]="moreDetailsOpen"
				>
					<span class="assignment-v2-accordion-copy assignment-v2-accordion-copy--inline">
						<span class="assignment-v2-accordion-title">
							{{ "ASSIGNMENT_MODAL__MORE_DETAILS" | transloco }}
						</span>
						@if (moreDetailsHint(); as hint) {
							<span class="assignment-v2-accordion-hint">{{ hint }}</span>
						}
					</span>
					<span class="material-symbols-outlined" aria-hidden="true">
						{{ moreDetailsOpen ? "expand_less" : "expand_more" }}
					</span>
				</button>

				@if (moreDetailsOpen) {
					<div class="assignment-v2-more">
						@if (definition && assignmentForm.controls.solution.value == null) {
							<label class="assignment-v2-field">
								<span class="assignment-v2-field-label">{{ "ASSIGNMENT__STATE" | transloco }}</span>
								<ion-select
									fill="outline"
									formControlName="definitionState"
									[compareWith]="compareWith"
								>
									<ion-select-option *ngFor="let state of states" [value]="state">
										{{ state.name }}
									</ion-select-option>
								</ion-select>
							</label>
						}

						@if (assets.nodes.length > 0) {
							<div class="assignment-v2-field">
								<span class="assignment-v2-field-label">{{ "ASSIGNMENT__ASSET" | transloco }}</span>
								<app-assignment-asset
									[assets]="assets"
									formControlName="asset"
									[v2]="true"
								></app-assignment-asset>
							</div>
						}

						@if (viewConfig.showCategories && categories.length > 0) {
							<div class="assignment-v2-field">
								<span class="assignment-v2-field-label">{{ "ASSIGNMENT__CATEGORIES" | transloco }}</span>
								<button
									type="button"
									class="assignment-v2-select-trigger"
									(click)="openCategoriesPicker()"
								>
									@if (categoriesSummary(); as summary) {
										<span class="assignment-v2-select-value">{{ summary }}</span>
									} @else {
										<span class="assignment-v2-select-placeholder">
											{{ "ASSIGNMENT__TAP_TO_SELECT" | transloco }}
										</span>
									}
									<span class="material-symbols-outlined" aria-hidden="true">chevron_right</span>
								</button>
							</div>
						}

						@if (definition && definition.categories.length > 0 && viewConfig.showDefinitionCategories) {
							<div class="assignment-v2-field">
								<span class="assignment-v2-field-label">
									{{ "ASSIGNMENT__DEFINITION_CATEGORIES" | transloco }}
								</span>
								<button
									type="button"
									class="assignment-v2-select-trigger"
									(click)="openDefinitionCategoriesPicker()"
								>
									@if (definitionCategoriesSummary(); as summary) {
										<span class="assignment-v2-select-value">{{ summary }}</span>
									} @else {
										<span class="assignment-v2-select-placeholder">
											{{ "ASSIGNMENT__TAP_TO_SELECT" | transloco }}
										</span>
									}
									<span class="material-symbols-outlined" aria-hidden="true">chevron_right</span>
								</button>
							</div>
						}
					</div>
				}

				@if (viewConfig.showResolve) {
					<button
						type="button"
						class="assignment-v2-accordion"
						(click)="solutionOpen = !solutionOpen"
						[attr.aria-expanded]="solutionOpen || !!assignmentForm.controls.solution.value"
					>
						<span class="assignment-v2-accordion-copy assignment-v2-accordion-copy--inline">
							<span class="assignment-v2-accordion-title">
								{{ "ASSIGNMENT_MODAL__ADD_SOLUTION" | transloco }}
							</span>
						</span>
						<span class="material-symbols-outlined" aria-hidden="true">
							{{
								solutionOpen || assignmentForm.controls.solution.value
									? "expand_less"
									: "expand_more"
							}}
						</span>
					</button>
					@if (solutionOpen || assignmentForm.controls.solution.value) {
						<div class="assignment-v2-more assignment-v2-solution">
							<app-assignment-solution
								formControlName="solution"
								[defintion]="definition"
							></app-assignment-solution>
						</div>
					}
				}

				<ion-popover [keepContentsMounted]="true">
					<ng-template>
						<ion-datetime
							formControlName="start"
							showClearButton="true"
							mode="md"
							name="start-v2"
							preferWheel="false"
							[showDefaultButtons]="true"
							[firstDayOfWeek]="1"
							id="start-v2"
						></ion-datetime>
					</ng-template>
				</ion-popover>

				<ion-popover [keepContentsMounted]="true">
					<ng-template>
						<ion-datetime
							formControlName="end"
							showClearButton="true"
							mode="md"
							name="deadline-v2"
							[min]="assignmentForm.controls.start.value"
							preferWheel="false"
							[showDefaultButtons]="true"
							[firstDayOfWeek]="1"
							id="deadline-v2"
						></ion-datetime>
					</ng-template>
				</ion-popover>
			</div>

			<footer class="assignment-v2-footer">
				<button type="button" class="assignment-v2-btn assignment-v2-btn--ghost" (click)="close()">
					{{ "ASSIGNMENT__BUTTON_CANCEL" | transloco }}
				</button>
				<button
					type="button"
					class="assignment-v2-btn assignment-v2-btn--primary"
					(click)="save()"
					[disabled]="assignmentForm.invalid"
				>
					{{
						(isCreate() ? "ASSIGNMENT_MODAL__CREATE_ACTION" : "ASSIGNMENT__BUTTON_SAVE")
							| transloco
					}}
				</button>
			</footer>
		}
		</div>
	</div>
} @else {
	<ion-header>
		<ion-toolbar>
			<ion-title>{{ "ASSIGNMENT_MODAL__TITLE" | transloco }}</ion-title>
			<ion-buttons slot="end">
				<ion-button (click)="close()">
					<ion-icon slot="icon-only" name="close-outline"></ion-icon>
				</ion-button>
			</ion-buttons>
		</ion-toolbar>
	</ion-header>

	<ion-content [formGroup]="assignmentForm" *ngIf="ready">
		<ion-list>
			@if (trigger != null) {
				<ion-item>
					@if (trigger.description === "") {
						<ion-label>{{ "ASSIGNMENT_MODAL__DESCRIPTION" | transloco }}</ion-label>
					} @else {
						<ion-label class="trigger-description">{{ trigger.description }}</ion-label>
					}
				</ion-item>
			}

			<ion-item lines="full">
				<ion-icon aria-hidden="true" name="build-outline" slot="start"></ion-icon>
				<ion-input
					class="title"
					#title
					labelPlacement="stacked"
					label="{{ 'ASSIGNMENT__TITLE' | transloco }}"
					errorText="{{ 'ASSIGNMENT__TITLE_EMPTY' | transloco }}"
					formControlName="title"
				></ion-input>
			</ion-item>

			<ion-item lines="full">
				<ion-icon name="chatbubble-outline" slot="start"></ion-icon>
				<div class="description-container">
					<ion-label position="stacked">{{ "ASSIGNMENT__DESCRIPTION" | transloco }}</ion-label>
					<quill-editor [modules]="modules" formControlName="description"></quill-editor>
				</div>
			</ion-item>

			<ion-item *ngIf="definition && assignmentForm.controls.solution.value == null" lines="full">
				<ion-icon aria-hidden="true" name="build-outline" slot="start"></ion-icon>
				<ion-select
					labelPlacement="stacked"
					justify="start"
					formControlName="definitionState"
					label="{{ 'ASSIGNMENT__STATE' | transloco }}"
					[value]="this.assignment.definitionState"
					[compareWith]="compareWith"
				>
					<ion-select-option *ngFor="let state of states" [value]="state">
						{{ state.name }}
					</ion-select-option>
				</ion-select>
			</ion-item>

			<ion-item *ngIf="definition && assignmentForm.controls.solution.value?.definitionState != null" lines="full">
				<ion-icon aria-hidden="true" name="build-outline" slot="start"></ion-icon>
				<ion-select
					label="{{ 'ASSIGNMENT__STATE' | transloco }}"
					labelPlacement="stacked"
					justify="start"
					[value]="assignmentForm.controls.solution.value.definitionState"
					disabled="true"
				>
					<ion-select-option [value]="assignmentForm.controls.solution.value.definitionState">
						{{ assignmentForm.controls.solution.value.definitionState.name }}
					</ion-select-option>
				</ion-select>
			</ion-item>

			@if (viewConfig.showPriority) {
				@if (definition?.priorities.length > 0) {
					<ion-item lines="full">
						<ion-icon name="star-outline" slot="start"></ion-icon>
						<ion-select
							labelPlacement="stacked"
							justify="start"
							formControlName="definitionPriority"
							label="{{ 'ASSIGNMENT__PRIORITY' | transloco }}"
							[value]="assignment.definitionPriority"
							[compareWith]="compareWith"
						>
							<ion-select-option *ngFor="let priority of definition.priorities" [value]="priority">
								{{ priority.name }}
							</ion-select-option>
						</ion-select>
					</ion-item>
				} @else {
					<ion-item>
						<ion-icon name="star-outline" slot="start"></ion-icon>
						<div class="priority-label">{{ "ASSIGNMENT__PRIORITY" | transloco }}</div>
						<ion-toggle class="piority" formControlName="priority" color="danger" justify="space-between">
							<ion-text
								*ngIf="
									assignmentForm.controls.priority.value === false ||
									assignmentForm.controls.priority.value == null
								"
							>
								{{ "ASSIGNMENT__PRIORITY_NO" | transloco }}
							</ion-text>
							<ion-text *ngIf="assignmentForm.controls.priority.value" color="danger">
								{{ "ASSIGNMENT__PRIORITY_YES" | transloco }}
							</ion-text>
						</ion-toggle>
					</ion-item>
				}
			}

			@if (assets.nodes.length > 0) {
				<app-assignment-asset [assets]="assets" formControlName="asset"></app-assignment-asset>
			}

			@if (viewConfig.showAssignee) {
				<app-assignment-assignees formControlName="assignees" [definition]="definition"></app-assignment-assignees>
			}

			<ion-item lines="full" *ngIf="viewConfig.showCategories && categories.length > 0">
				<ion-icon name="pricetag-outline" slot="start"></ion-icon>
				<ion-select
					labelPlacement="stacked"
					justify="start"
					formControlName="categories"
					label="{{ 'ASSIGNMENT__CATEGORIES' | transloco }}"
					placeholder="{{ 'ASSIGNMENT__TAP_TO_SELECT' | transloco }}"
					[multiple]="true"
					[value]="assignmentForm.controls.categories.value"
				>
					<ion-select-option *ngFor="let category of categories" [value]="category">
						{{ category }}
					</ion-select-option>
				</ion-select>
			</ion-item>

			@if (definition && definition.categories.length > 0 && viewConfig.showDefinitionCategories) {
				<ion-item lines="full">
					<ion-icon name="pricetag-outline" slot="start"></ion-icon>
					<ion-select
						labelPlacement="stacked"
						justify="start"
						formControlName="definitionCategories"
						label="{{ 'ASSIGNMENT__DEFINITION_CATEGORIES' | transloco }}"
						placeholder="{{ 'ASSIGNMENT__TAP_TO_SELECT' | transloco }}"
						[multiple]="definition.categorySelectionType === 'Multiple'"
					>
						<ion-select-option *ngFor="let category of definition.categories" [value]="category.id">
							{{ category.name }}
						</ion-select-option>
					</ion-select>
				</ion-item>
			}

			@if (viewConfig.showDateTime) {
				<ion-item lines="full">
					<ion-icon name="time-outline" slot="start"></ion-icon>
					<ion-label>
						{{ "ASSIGNMENT__TIME_START" | transloco }}
					</ion-label>
					<ion-datetime-button datetime="start">
						@if (assignmentForm.controls.start.value == undefined) {
							<ion-icon name="calendar" slot="date-target"></ion-icon>
							<ion-icon name="time-outline" slot="time-target"></ion-icon>
						}
					</ion-datetime-button>
				</ion-item>
				<ion-item lines="full">
					<ion-icon name="time-outline" slot="start"></ion-icon>
					<ion-label>
						{{ "ASSIGNMENT__DEADLINE" | transloco }}
					</ion-label>
					<ion-datetime-button datetime="deadline">
						@if (assignmentForm.controls.end.value == undefined) {
							<ion-icon name="calendar" slot="date-target"></ion-icon>
							<ion-icon name="time-outline" slot="time-target"></ion-icon>
						}
					</ion-datetime-button>
				</ion-item>
			}

			<ion-item>
				<app-attachments formControlName="attachments" [showAttachments]="true"></app-attachments>
			</ion-item>

			@if (viewConfig.showResolve) {
				<app-assignment-solution formControlName="solution" [defintion]="definition"></app-assignment-solution>
			}
		</ion-list>

		<ion-popover [keepContentsMounted]="true">
			<ng-template>
				<ion-datetime
					formControlName="start"
					showClearButton="true"
					mode="md"
					name="start"
					preferWheel="false"
					[showDefaultButtons]="true"
					[firstDayOfWeek]="1"
					id="start"
				></ion-datetime>
			</ng-template>
		</ion-popover>

		<ion-popover [keepContentsMounted]="true">
			<ng-template>
				<ion-datetime
					formControlName="end"
					showClearButton="true"
					mode="md"
					name="deadline"
					[min]="assignmentForm.controls.start.value"
					preferWheel="false"
					[showDefaultButtons]="true"
					[firstDayOfWeek]="1"
					id="deadline"
				></ion-datetime>
			</ng-template>
		</ion-popover>
	</ion-content>
	<ion-footer *ngIf="ready">
		<ion-toolbar>
			<div class="button-container">
				<ion-button (click)="save()" shape="round" [disabled]="assignmentForm.invalid">
					<ion-label>{{ "ASSIGNMENT__BUTTON_SAVE" | transloco }}</ion-label>
				</ion-button>
			</div>
		</ion-toolbar>
	</ion-footer>
}
